<template>
  <div class="window-aside-right">
    <!--改价弹窗-->
    <el-dialog title="修改订单金额" :visible.sync="dialogVisible" width="400px" :before-close="handleClose" :close-on-click-modal="false">
      <el-form>
        <el-form-item label="是否包赔">
          <el-switch v-model="is_bp"></el-switch>
        </el-form-item>

        <el-form-item label="">
          <el-input @keydown.native="inputKeydown" @keydown.native.enter.prevent v-model="input"
                    placeholder="请输入修改订单金额"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
                <el-button @click="btnCancle">取 消</el-button>
                <el-button type="primary" @click="btnOK">确 定</el-button>
            </span>
    </el-dialog>



    <!-- Tabs 面板 -->
    <el-tabs v-model="tabsActiveIndex" :stretch="true" @tab-click="handleTabClick">
      <!-- 用户资料 -->
      <el-tab-pane :label="chatType == 'group' ? '群组信息' : '用户资料'" :name="TabsMap['USER']">
        <div class="tab-content"  v-if="chatType != 'group'">
          <div class="user-info" v-if="userInfo.nickname">
            <div class="info-header flex">
              <img class="avatar m-r-10" :src="userInfo.avatar"/>
              <div>
                <div class="name line-2">{{ userInfo.nickname }}</div>
                <div class="name line-2 uid">UID:{{userInfo.id}}</div>
              </div>
            </div>
            <div class="info-item">
              <span class="label">真实姓名：</span>
              <span>{{ userInfo.real_name==''?"用户尚未实名":userInfo.real_name }}</span>
            </div>
            <div class="info-item">
              <span class="label">真实年龄：</span>
              <span>{{ userInfo.age }}</span>
            </div>
            <div class="info-item">
              <span class="label">身份证号：</span>
              <span>{{ userInfo.card }}</span>
            </div>
            <div class="info-item">
              <span class="label">注册时间：</span>
              <span>{{ userInfo.create_time }}</span>
            </div>
            <div class="info-item">
              <span class="label">注册来源：</span>
              <span>{{ userInfo.channel | Channel }}</span>
            </div>
            <div class="info-item">
              <span class="label">IP来源：</span>
              <span>{{ userInfo.login_ip }}</span>
            </div>
            <div class="info-item">
              <span class="label">IP地址：</span>
              <span>{{ userInfo.ip }}</span>
            </div>
          </div>
          <!-- 用户浏览/议价 -->
          <div>
            <el-tabs value="viewrecords" @tab-click="handleTabClick">
              <el-tab-pane label="商品浏览记录" name="viewrecords">
                <el-scrollbar class="ls-scrollbar" style="width:275px;height: 290px;overflow-x:hidden;"  v-if="chatType != 'group'">
                  <div class="order-list" v-if="useLookList.length">
                    <div class="order-item" v-for="(item, index) in useLookList" :key="index" v-if="item.goods!=null">
                      <a :href="'http://tenant.yxbds.com/#/stock/lists/add?id=' + item.goods_id"
                          target="_blank">
                        <el-image style="width: 100%; height: 100px"
                                  fit="cover"
                                  :src="item.goods.thumb"></el-image>
                      </a>
                      <el-row >
                        <el-col >
                          <div>浏览次数：{{ item.count }} 次</div>
                        </el-col>
                        <el-col >
                          <div class="ellipsis">商品编号：{{ item.goods_id }}
                            <a :href="'http://tenant.yxbds.com/#/stock/lists/add?id=' + item.goods_id" target="_blank"  >
                              <i class="el-icon-s-promotion"></i>
                            </a>
                          </div>
                        </el-col>
                      </el-row>
                      <div class="game_name">游戏名称：{{ games[item.game_id].name }}</div>
                      <div class="ellipsis">商品名称： {{ item.goods.name }}</div>
                      <div>商品价格：<span class="goods-price">￥{{ item.goods.price }}</span></div>
                      <div>浏览时间：{{ item.update_time }}</div>
                      <div>
                        <el-button type="primary" @click="sendGoods(item.goods_id)" class="btn-send" size="small">发送咨询商品链接</el-button>
                      </div>
                    </div>
                  </div>
                </el-scrollbar>
              </el-tab-pane>
              <el-tab-pane label="正在议价商品" name="redus">
                <el-scrollbar class="ls-scrollbar" style="width:275px;height: 290px;overflow-x:hidden;"   v-if="chatType != 'group'">
                  <div class="redu" v-for="item in userRedus">
                    <a :href="'http://tenant.yxbds.com/#/stock/lists/add?id=' + item.goods_id" target="_blank" >
                      <div class="game_thumb">
                        <el-image style="width: 100%; height: 100px" fit="cover" :src="item.thumb"></el-image>
                        <div class="redu_goods_name">
                          <div class="ellipsis">{{ item.name }}</div>
                        </div>
                      </div>
                    </a>
                    <div class="redu_info">
                      <div class="game_name">
                        议价状态:
                        <el-tag size="mini" :type="item.status|statusFilter">
                          {{ item.status | statusTextFilter }}
                        </el-tag>
                      </div>
                      <div class="game_name">
                        商品编号:{{ item.goods_id }}
                        <a :href="'http://tenant.yxbds.com/#/stock/lists/add?id=' + item.goods_id" target="_blank"  >
                          <i class="el-icon-s-promotion"></i>
                        </a>
                      </div>
                      <div class="game_name">
                        游戏名称:{{ games[item.game_id].name }}
                      </div>
                      <div class="redu_price old_price">
                        商品原价:¥{{ item.goods_price }}
                      </div>
                      <div class="redu_price">
                        用户出价:¥{{ item.price }}
                      </div>
                      <div class="redu_price saler_price">
                        卖家还价:¥{{ item.h_price || '暂未还价' }}
                      </div>
                      <div class="redu_time">
                        更新时间:{{ item.update_time }}
                      </div>
                      <el-button type="primary" @click="sendGoods(item.goods_id,'bargain')" class="btn-send" size="small">发送商品支付链接</el-button>
                      <el-button v-if="item.status==0" type="success" @click="accpetRedu(item.id)" class="btn-send" size="small">同意</el-button>
                      <el-button v-if="item.status==0" type="danger" @click="refuseRedu(item.id)" class="btn-send" size="small">拒绝</el-button>
                    </div>
                  </div>
                </el-scrollbar>
              </el-tab-pane>
            </el-tabs>
          </div>
          <!-- <el-empty v-else :image-size="100">


          </el-empty> -->
        </div>
        <div class="tab-content" v-else>
          <div class="user-info">
            <div class="info-header flex">
              <img class="avatar m-r-10" :src="userInfo.avatar"/>
              <div class="name line-2">{{ userInfo.name }}</div>
            </div>
            <div class="info-item">
              <span class="label">群组编号：</span>
              <span>{{ userInfo.group_id }}</span>
            </div>
            <div class="info-item">
              <span class="label">创建时间：</span>
              <span>{{ userInfo.create_time }}</span>
            </div>
            <div class="info-item">
              <span class="label">交易状态：</span>
              <span>{{ dealStatus[userInfo.deal_status] }}</span>
            </div>

          </div>
          <div class="members">
            <div style="font-size:12px;padding:2px 10px;color:#666">用户列表（{{this.users.length}}/20）
              <i class="widget-item el-icon-circle-plus-outline pointer" @click="showAddMemberDialog=true"></i>
            </div>
            <div class="group_user" v-for="(item,index) in users" @click="toPrivate(item.user_id)">
                <div class="avatar">
                  <el-image fit="contain" :src="'https://img.taohaozhijia.cn/'+item.user.avatar"></el-image>
                  <div class="online" v-if="item.online">在线</div>
                  <div class="online off" v-else>离线</div>
                </div>
                <div class="nickname">
                  <div>
                    <div>{{item.user.nickname}}</div>
                    <span class="role" :class="'role_'+item.role">{{roles[item.role]}}</span>
                  </div>
                </div>
            </div>
          </div>

        </div>
      </el-tab-pane>

      <!-- 订单信息 @tab-click="getUserOrder()"-->
      <el-tab-pane :label="chatType == 'group' ? '交易进度' : '订单信息'" :name="TabsMap['ORDER']"  >
        <div  v-if="chatType != 'group'" style="height: 555px;margin:5px">
          <el-form>
            <el-form-item  class="search_order" label="订单号">
              <el-input v-model="orderSn"  size="small"  placeholder="请输入订单号搜索" @keydown.enter.native.stop="searchFn"></el-input>
            </el-form-item>
          </el-form>
          <div class="order-status-links">
            <el-link class="order-status-link" :class="tabsOrderStatus==='all'?'active':''" @click="tabsOrderStatus='all';handleOrderStatusClick();">全部订单</el-link>
            <el-link class="order-status-link" :class="tabsOrderStatus==='prepay'?'active':''"  @click="tabsOrderStatus='prepay';handleOrderStatusClick();">待支付</el-link>
            <el-link class="order-status-link" :class="tabsOrderStatus==='dealing'?'active':''"   @click="tabsOrderStatus='dealing';handleOrderStatusClick();">交易中</el-link>
            <el-link class="order-status-link" :class="tabsOrderStatus==='finished'?'active':''"   @click="tabsOrderStatus='finished';handleOrderStatusClick();">已完成</el-link>
            <el-link class="order-status-link" :class="tabsOrderStatus==='cancel'?'active':''"  @click="tabsOrderStatus='cancel';handleOrderStatusClick();">已取消</el-link>
            <el-link class="order-status-link" :class="tabsOrderStatus==='refund'?'active':''"  @click="tabsOrderStatus='refund';handleOrderStatusClick();">售后/退款</el-link>
          </div>

          <el-scrollbar class="ls-scrollbar" style="height: 480px" >
            <loading-more v-model="status" @load="getUserOrderTop" v-if="toId">
              <div class="tab-content">
                <div class="order-info">
                  <div class="order-list" v-if="orderLists.length">
                    <div class="order-item" v-for="(item, index) in orderLists" :key="index">
                      <div class="order-goods flex col-top" v-for="(gitem, gindex) in item.order_goods" :key="gindex">
                        <div class="flex-none">
                          <el-image fit="cover" :src="gitem.thumb" style="width: 68px;height: 68px;" />
                        </div>
                        <div class="flex-1 m-l-8" style="min-width: 0">
                          <div class="goods-name line-1">{{ gitem.name }}</div>
                          <div class="muted m-t-5">{{ gitem.spec_value_str }}</div>

                          <div class="price flex row-between m-t-5">
                            <div class="nr">
                              ￥{{ gitem.price }}
                            </div>
                            <div class="muted">x{{ gitem.goods_num }}</div>
                          </div>
                        </div>
                      </div>
                      <div class="order-con">
                        <div class="m-t-5">
                          <a style="display: flex;"
                             :href="'http://tenant.yxbds.com/#/stock/lists/add?id=' + item.goods_id"
                             target="_blank">
                            <div class="flex-none">
                              <el-image :src="item.thumb" fit="cover" style="width: 68px;height: 68px;"></el-image>
                            </div>
                            <div class="flex-1 m-l-8" style="min-width: 0;height: 70px;overflow: overlay;">
                              <div class="goods-name">{{ item.name }}</div>
                            </div>
                          </a>
                        </div>
                        <div class="m-t-15">
                          <span class="muted">游戏名称：</span>
                          <span>{{ games[item.game_id].name }}</span>
                        </div>
                        <div class="m-t-15">
                          <span class="muted">商品编号：</span>
                          <span>{{ item.goods_id }}
                           <a :href="'http://tenant.yxbds.com/#/stock/lists/add?id=' + item.goods_id" target="_blank"  >
                              <i class="el-icon-s-promotion"></i>
                           </a>
                          </span>
                        </div>
                        <div class="m-t-15">
                          <span class="muted">订单编号：</span>
                          <span>{{ item.sn }}</span>
                          <i class="iconfont icon-copy" @click="copy(item.sn)"></i>
                        </div>
                        <div class="m-t-15">
                          <span class="muted">订单状态：</span>
                          <span v-if="item.status == 5" class="order-status danger-pay">
                                 退款/售后
                          </span>

                          <span v-else class="order-status" :class="{'wait-pay':item.status == 0,}">
                                {{ order_status[item.status] }}
                          </span>
                        </div>

                        <!-- status:5 退款 -->
                        <div v-if="item.status == 5">
                          <div class="m-t-15">
                            <span class="muted">退款订单状态：</span>
                            <span style="color: red">{{ item.refund_content?.refund_status_text }}</span>
                          </div>

                          <div class="m-t-15">
                            <span class="muted">退款金额：</span>
                            <span style="color: red">{{ item.refund_content?.refund_amount }}</span>
                          </div>
                        </div>
                        <div class="m-t-15">
                          <span class="muted">商品金额：</span>
                          <span>{{ item.goods_price || (item.bp_amount * 10).toFixed(2) }}</span>
                          <el-button @click="btnFn(item,item.goods_price || (item.bp_amount*10).toFixed(2))"
                                     v-if="item.status == 3" type="primary" icon="el-icon-edit"
                                     size="small" class="my-btn">改价
                          </el-button>
                        </div>
                        <div class="m-t-15">
                          <span class="muted">是否包赔：</span>
                          <span style="color: red;">{{ item.is_bp | bp_filter }}</span>
                        </div>
                        <div class="m-t-15">
                          <span class="muted">订单金额：</span>
                          <span>{{ item.order_amount }}</span>
                        </div>
                        <div class="m-t-15">
                          <span class="muted">下单时间：</span>
                          <span>{{ item.create_time }}</span>
                        </div>
                        <div class="m-t-15" style="text-align: center;">
                          <el-button @click="btnSendFn(item)" v-if="item.status == 3"
                                     type="danger" class="btn-send" size="mini">发送订单支付链接
                          </el-button>
                        </div>
                      </div>

                      <div v-if="item.group_info.name">
                        <div class="m-t-15">
                          <span class="muted">群组名称：</span>
                          <span>
                            {{item.group_info.name}}
                            <i class="el-icon-s-promotion pointer" @click="JumpToGroup(item.group_info)"></i>
                          </span>
                        </div>
                        <div class="m-t-15">
                          <span class="muted">群组状态：</span>
                          <span><el-tag size="mini" :type="dealStatusTag(item.group_info.deal_status)">{{dealStatus[item.group_info.deal_status] }}</el-tag></span>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </loading-more>
          <el-empty v-else :image-size="100"></el-empty>
        </el-scrollbar>
        </div>
        <div v-else>
          <div class="goodsInfo">
            <div class="goods">
              <div class="thum">
                <el-image fit="cover"
                          style="height:140px;border-radius: 5px;
                          overflow: hidden"
                          :preview-src-list="imgList"
                          :src="progressData.thumb" >
                </el-image>

              </div>
              <div >
                <div class="info-item">
                  <span class="label">游戏名称：</span>
                  <span>{{ games[progressData.game_id]?.name }}</span>
                </div>
                <div class="info-item">
                  <span class="label">包赔类型：</span>
                  <span>{{ progressData.is_bp==1?'普通包赔':'不含包赔' }}</span>
                </div>
                <div class="info-item" v-if="progressData.is_bp">
                  <span class="label">包赔费用：</span>
                  <span>{{ progressData.bp_amount }}</span>
                </div>
                <div class="info-item">
                  <span class="label">订单状态：</span>
                  <span>{{ dealStatus[userInfo.deal_status] }}</span>
                </div>
                <div class="info-item">
                  <span class="label">成交金额：</span>
                  <span>{{ progressData.order_amount }}</span>
                </div>
                <div class="info-item" v-if="progressData.coupon_amount>0">
                  <span class="label">优惠金额：</span>
                  <span>{{progressData.coupon_amount}}</span>
                </div>
              </div>
            </div>
            <div class="orderInfo">
              <div class="info-item">
                <span class="label">商品编号：</span>
                <span>{{ progressData.goods_id }}</span>
                <span>
                  <a :href="'http://tenant.yxbds.com/#/stock/lists/add?id=' + progressData.goods_id" target="_blank"  >
                    <i class="el-icon-s-promotion"></i>
                  </a>
                </span>
              </div>
              <div class="info-item">
                <span class="label">商户名称：</span>
                <span>{{ progressData.dept}}</span>
              </div>
              <div class="info-item">
                <span class="label">游戏账号：</span>
                <span>{{ progressData.account }}</span>
                <i class="iconfont icon-copy" @click="copy(progressData.account)"></i>
              </div>
              <div class="info-item">
                <span class="label">订单编号：</span>
                <span>{{ progressData.sn }}</span>
                <i class="iconfont icon-copy" @click="copy(progressData.sn)"></i>

              </div>
              <div class="info-item">
                <span class="label">创建时间：</span>
                <span>{{ progressData.create_time }}</span>
              </div>
            </div>
            <div class="progress">
              <div class="progress_log" v-for="(item,index) in progressData.log">
                <div class="progress_info">
                  <div class="progress_icon">
                    <div class="inline progress-circle" :class="index==0?'on':''"></div>
                  </div>
                  <div class="log_data">
                    <div class="title">{{item.title}}</div>
                    <div class="log_info">
                      <div class="log">{{item.log}}</div>
                      <div class="create_time">{{item.create_time}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

      </el-tab-pane>
    </el-tabs>

    <el-dialog title="拒绝议价" :visible.sync="bargain_disagree" width="350px">
      <div class="kanjia_dialog">
        <div style="margin-top: 20px">
          <el-image
              style="width: 80px; height: 80px"
              :src="require('@/assets/images/disagree.png')">
          </el-image>
        </div>

        <div class="text1">
          <span>不同意议价</span>
        </div>

        <div class="text2">
          <span>确认不同意当前用户发起的议价金额吗?</span>
        </div>

        <div class="text3">
          <span>是否继续还价</span>
          <el-radio v-model="radio" label="disAgree">拒绝还价</el-radio>
          <el-radio v-model="radio" label="agree">继续还价</el-radio>
        </div>

        <div class="input" v-if="radio == 'agree'">
          <div class="text">还价金额</div>
          <el-input type="number" v-model="redu_price" size="small" placeholder="请输入还价金额" />
        </div>

        <div class="btn">
          <el-button size="medium" round type="danger" @click="refuseBargain">确 定</el-button>
        </div>
      </div>

    </el-dialog>
    <el-dialog title="添加成员" :visible.sync="showAddMemberDialog" width="300px">
      <el-form>
        <el-form-item label="用户手机号">
          <el-input v-model="userPhone" placeholder="请输入商户绑定用户手机号"></el-input>
        </el-form-item>
        <el-form-item align="right">
          <el-button type="info" size="small" @click="showAddMemberDialog = false">取消</el-button>
          <el-button type="primary" size="small" @click="checkMemberInfo">添加成员</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog  title="确认添加成员" :visible.sync="showPreMemberDialog" width="300px">
      确认添加该成员吗？
      <div class="avatar-nickname">
        <el-avatar :src="'https://img.taohaozhijia.cn/'+preUserInfo.avatar"></el-avatar>
        <div>
          <div>{{userPhone}}</div>
          <div>{{preUserInfo.nickname}}</div>
        </div>

      </div>
      <template #footer>
        <el-button size="small" type="primary" @click="addMember">确认添加</el-button>
      </template>
    </el-dialog>
  </div>
</template>


<script>
import yanhao from '@/assets/images/1.png';
import huanbang from '@/assets/images/2.png';
import wancheng from '@/assets/images/3.png';
import quxiao from '@/assets/images/4.png';
import shouhou from '@/assets/images/5.png';

import {
  addGroupMember,
  checkUserInfo,
  apiUserInfo,
  getOrderProgress,
  apiUserOrder,
  apiServiceList,
  customer,
  orderList,
  apiUserLookRecord,
  apiServiceMoney,
  apiServiceSendOrderMsg,
  getGoodsInfoById,
  bargainPrice,
  sellerDickerBargain,
  apiServiceSendGoodsMsg
} from '@/api/app'
import LoadingMore from '@/components/LoadingMore'
import {E_Load} from '@/utils/enum'
import {Message} from "element-ui";

export default {
  name: 'TheWindowAsideRight',
  components: {
    LoadingMore,
  },
  props: {
    toId: {
      type: [Number, String],
    },
    chatType: {
      type: [Number, String],
    }
  },

  inject: ['send'],
  data() {
    return {
      bargain_disagree:false,
      games: {},
      roles:{
        '1':'买家',
        '2':'卖家',
        '3':'官方'
      },
      group_avatar: {
        1: yanhao,
        2: huanbang,
        3: wancheng,
        4: quxiao,
        5: shouhou
      },
      inputId: '',
      input: '',
      is_bp: false,
      dialogVisible: false,
      dialogVisible_goods: false,
      goodsInfo: {},
      /* Tabs 索引 */
      tabsActiveIndex: '',
      /* Tabs 映射 */
      TabsMap: Object.freeze({
        USER: '1',
        ORDER: '2',
      }),
      // 订单编号
      orderSn: '',
      userInfo: {},
      orderLists: [],
      //用户浏览记录
      useLookList: [],
      showKefu: false,
      KefuLists: [],
      users:[],
      page: 1,
      size: 15,
      radio:"agree",
      redu_price:null,
      imgList:[],
      query: {
        page_no: 1,
        page_size: 4,
      },
      status: E_Load['NORMAL'],
      order_status: {
        "3": '待支付',
        '2': '已取消',
        '4': '交易中',
        '1': '交易成功',
        '5': '已退款'
      },
      tabsOrderStatus:"all",
      user_types:{"1":"user_","2":"kefu_"},
      userRedus: [],
      bargain_id:null,
      progressData:{},
      selectValue: 'order',
      dealStatus:{1:"验号中",2:"换绑中",3:"已完成",4:"已取消"},
      showAddMemberDialog:false,
      showPreMemberDialog:false,
      userPhone:'',
      preUserInfo:{}
    }
  },
  mounted() {
    this.$event.$on('connected',()=>{
      this.$net.socket.on('onlineUser',this.setUserOnline.bind(this));
      this.$net.socket.on('offlineUser',this.setUserOffline.bind(this));
      this.$net.socket.on('online',this.setOnlineUserStatus.bind(this));
      this.$net.onlineUsers();
    });
    this.$event.$on('disconnected',()=>{
      this.toId=undefined;
      this.userInfo = {};
      this.orderLists = []
      this.useLookList = []
      this.userRedus = [];
    })
    this.$event.$on('group_info_update',this.getUserInfo);
  },
  watch: {
    async toId(val) {
      this.page = 1
      this.orderLists = []
      this.useLookList = []
      this.orderSn = '';
      this.query.page_no = 1;
      if (!val) {
        this.userInfo = {}
        return
      }
      await this.getUserInfo()
      await this.getUserOrder()
      await this.getUserRedus();
      this.$net.onlineUsers();
      if(this.chatType === 'group'){
        await this.getGroupOrderProgress();
      }
    },
    status(val, val2) {
    }
  },
  methods: {
    async checkMemberInfo(){
      const res = await checkUserInfo({mobile:this.userPhone});
      if(res.data){
          this.preUserInfo = res.data;
          this.showPreMemberDialog = true;
      }
    },
    async addMember (){
        const res = await addGroupMember({mobile:this.userPhone,group_id:this.toId});
        this.users.push(res.user);
        this.showAddMemberDialog = false;
        this.showPreMemberDialog = false;
    },
    async handleOrderStatusClick(){
      const map = {"all":undefined,"finished":1,"cancel":2,"prepay":3,"dealing":4,"refund":5};
      const res = await orderList({
        url: `page_no=${this.query.page_no}&page_size=${this.query.page_size}`,
        data: {
          userId: this.toId,
          sn:this.orderSn,
          status: map[this.tabsOrderStatus]
        }
      });
      this.orderLists = res.lists;
    },
    JumpToGroup(group_info){
      let item = {
        "type":"group",
        "group":group_info,
            ...group_info,
      }
      this.$event.$emit('openGroupThread',item);
    },
    dealStatusTag(val){
      const map = {1:"primary",2:"warning",3:"success",4:"danger"};
      return map[val];
    },
    copy(text){
      const r = navigator.clipboard.writeText(text);
      if(r) Message.success('复制成功');
    },
    //拒绝议价/继续还价
    async refuseBargain(){
      if(this.bargain_id == null) return;
       //继续还价
       if(this.radio == 'agree') {
          await sellerDickerBargain({
            bargainId: this.bargain_id,
            msgId:undefined,
            status: 3,
            price: this.redu_price
          })
        }else if(this.radio == 'disAgree') { //直接拒绝还价
          await bargainPrice({
            bargainId:this.bargain_id,
            msgId: undefined,
            status: 2 //拒绝
          })
        }
        this.getUserRedus();
        this.bargain_id = null;
        this.redu_price = null;
        this.bargain_disagree = false;
    },
    async getGroupOrderProgress(){
        if(this.chatType=='group'){
          this.progressData = await getOrderProgress({'group_id': this.toId,'order_id':this.userInfo.order_id});
          this.imgList = [];
          this.imgList.push(this.progressData.thumb);
        }
    },
    async handleTabClick(tab, event) {
      if (tab.name == this.TabsMap['ORDER']) {
        await this.getUserOrder();
        await this.getUserRedus();
      }
      if(this.chatType=='group'){
        await this.getGroupOrderProgress();
      }

    },
    async setOnlineUserStatus(msg){
      let online_users = Object.values(msg);
      this.users = this.users.map((item)=>{
        if (online_users.indexOf(this.user_types[item.user_type]+item.user_id) >= 0) {
          item.online  = true;
        }
        return item;
      })
    },
    async setUserOnline(userId){
      this.users = this.users.map((item)=>{
          if (this.user_types[item.user_type]+item.user_id == userId) {
             item.online = true;
          }
          return item;
      })
    },
    async setUserOffline(userId){
      this.users = this.users.map((item)=>{
          if (this.user_types[item.user_type]+item.user_id == userId) {
            item.online = false;
          }
          return item;
      })
    },
    async getUserRedus() {
      let datas = await this.$http.post('tenantapi/kefu.bargain/lists', {user_id: this.toId, 
      page_no:1,page_size: 15});
      this.userRedus = datas.lists;
      this.$event.$emit("updateWaitBargainCount");
    },
    async searchFn() {
      if (this.selectValue == 'order') {// 订单号
          this.refresh()
      } else if (this.selectValue == 'goods') { //商品编号
        const res = await getGoodsInfoById({
          goods_id: this.orderSn
        })
        if (res.success === false) {
          Message({type: 'error', message: res.msg});
        } else {
          this.goodsInfo = res
          this.dialogVisible_goods = true
        }
      }else if (this.selectValue == 'erp') { //商品编号
        const res = await getGoodsInfoById({
          erp_id: this.orderSn
        })
        if (res.success === false) {
          Message({type: 'error', message: res.msg});
        } else {
          res.game_name = res.category_name
          res.serverName = res.qufu
          this.goodsInfo = res
          this.dialogVisible_goods = true
        }
      }

    },
    btnFn(item, money) {
      this.dialogVisible = !this.dialogVisible
      this.input = money
      if (item.is_bp == '1') {
        this.is_bp = true
      }
      this.inputId = item.id
    },
    async btnSendFn(item) {
      this.$confirm('是否确认发送订单支付链接?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await apiServiceSendOrderMsg({
          order_id: item.id,
        })
        this.$message({
          type: 'success',
          message: '发送成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消发送'
        });
      });
    },
    async accpetRedu(id){
      await bargainPrice({
        bargainId: id,
        msgId: undefined,
        status: 1 //同意
      });
      this.getUserRedus();
    },
    async refuseRedu(id){
      this.bargain_disagree = true;
      this.bargain_id = id;
    },
    async sendGoods(id,type=undefined) {
      await apiServiceSendGoodsMsg({
        goods_id: id,
        user_id: this.toId,
        type:type
      })
      this.$message({
        type: 'success',
        message: '发送成功!'
      });
    },
    getUserOrderTop() {
      this.query.page_no++;
      this.getUserOrder();
    },
    refresh() {
      this.page = 1
      this.orderLists = []
      this.useLookList = []
      this.getUserOrder()
    },
    async getUserInfo() {
      if (this.chatType === 'group') {
        const data = await this.$http.get('/tenantapi/kefu.kefu/groupInfo?group_id=' + this.toId);
        data.user_id = data.group_id;
        this.userInfo = data;
        this.users = data.userInfo;
        this.userInfo.avatar = this.group_avatar[data.deal_status];
        this.$net.onlineUsers();
        this.$event.$emit('group_info_load', data);
        await this.getGroupOrderProgress();
        return;
      }
      let info = await customer({
        userId: this.toId
      })
      if (info.nickname) {
        this.userInfo = info;
        this.$event.$emit('user_info_load', info);
      }
    },
    async getUserOrder() {
      // if (this.status == E_Load['EMPTY']) return
      let order = await orderList({
        url: `page_no=${this.query.page_no}&page_size=${this.query.page_size}`,
        data: {
          sn:this.orderSn,
          userId: this.toId
        }
      })

      //获取用户浏览记录
      let useLook = await apiUserLookRecord({
        url: `page_size=${this.query.page_size}`,
        userId: this.toId
      })
      this.useLookList = useLook.lists

      if (this.query.page_no == 1) {
        this.orderLists = order.lists;
      } else {
        this.orderLists.push(...order.lists);
      }

      this.status = E_Load['EMPTY'];
    },
    btnCancle() {
      this.dialogVisible = false;
    },
    btnOK() {
      let bp = 0
      if (this.is_bp == true) {
        bp = 1
      }
      apiServiceMoney({
        order_id: this.inputId,
        price: this.input,
        is_bp: bp
      }).then(() => {
        this.$message({
          type: 'success',
          message: '修改成功'
        });
        this.refresh();
      })
      this.handleClose();
    },
    handleClose() {
      this.input = ''
      this.is_bp = false
      this.inputId = ''
      this.dialogVisible = false;
    },
    inputKeydown() {
      if (event.keyCode === 13) {
        this.btnOK()
      }
    },
    async getGames() {
      let datas = await this.$http.get('tenantapi/kefu.kefu/gameMenu');
      this.games = {};
      for (let i = 0; i < datas.length; i++) {
        this.games[datas[i].id] = datas[i];
      }
    },
    //关键字搜索类型切换
    handleCommand(command) {
      this.selectValue = command
    },
    //转聊天
    toPrivate(uid){
      this.$event.$emit('open_private', uid);
    }
  },
  async created() {
    await this.getGames();
    /* 初始化Tabs选项 */
    this.tabsActiveIndex = this.TabsMap['USER'];
  },
  filters: {
    statusFilter(val) {
      if (val == '0') {
        return "primary"
      } else if (val == '1') {
        return "success"
      } else if (val == '2') {
        return "danger"
      } else if (val == '3') {
        return "warning"
      }
    },
    statusTextFilter(val) {
      if (val == '0') {
        return "待审核"
      } else if (val == '1') {
        return "已审核"
      } else if (val == '2') {
        return "已拒绝"
      } else if (val == '3') {
        return "已还价"
      }
    },
    selectFilters(val) {
      if (val == 'order') {
        return "订单号"
      } else if (val == 'goods') {
        return "商品编号"
      } else if (val == 'erp') {
        return "ERP_ID"
      }
    },
    price(val, old) {
      if (val == null) {
        return old;
      }
      return val;
    },
    bp_filter(val) {
      if (val == '1') {
        return "是"
      } else {
        return "否"
      }
    },
    Channel(val){
      //注册渠道: [1-微信小程序 2-微信公众号 3-手机H5 4-电脑PC 5-苹果APP 6-安卓APP 7-VIVO 8-OPPO 9-华为 10-小米]
      let map = {1:"微信小程序",2:'微信公众号',3:'手机H5',4:'电脑PC',5:'苹果APP',6:'安卓APP',7:'VIVO渠道',8:'OPPO渠道',9:'华为渠道',10:'小米'};
      return map[val]??'未知渠道';
    }
  }
}
</script>


<style lang="scss" scoped>
.ellipsis {
  width:100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.order-status-links{
  margin-bottom: 4px;
}
.order-status-link{
  margin-left: 6px;
  font-size: 12px;
}
.order-status-link.active{
  color:#409EFF;
}
.window-aside-right {
  overflow-x: hidden;
  height: 630px;
  .tab-content {
    padding: 0 10px;

    :deep(.el-input__inner ) {
      height: 35px;
    }
    .user-info {
        background: #f5f5f5;
        padding-bottom: 5px;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
      .info-header {
        padding: 10px;

        .avatar {
          width: 38px;
          height: 38px;
          border-radius: 50%;
        }
      }


      }
    }
  .goodsInfo{
    padding: 0px 5px;
    .goods{
      height: 160px;
      display: flex;
      border-bottom:  1px solid #efefef;
      margin-bottom: 10px;
      .thum{
        overflow: hidden;
        width: 120px;
        border-radius: 5px;
      }
    }
    .orderInfo{
      border-bottom:  1px solid #efefef;
      margin-bottom: 10px;
    }
    .progress{
      color:#666;
      .progress_log{
        margin-bottom: 10px;
      }
      .progress-circle{
        padding: 6px;
        border-radius: 100%;
        background: #ccc;
        margin-right: 5px;
      }
      .progress-circle.on{
        background: #3f6de6;
      }
      .progress_info{
        display: flex;
        .title{
          color:#000;
        }
        .log_data{
          width: 100%;
          display: flex;
          gap:2px;
          flex-direction: column;
        }
        .log_info{
          font-size: 12px;
          display: flex;
          justify-content: space-between;
          color:#ccc;
        }
      }
    }
  }
  .info-item {
    padding: 0 10px;
    font-size: 12px;
    margin-bottom: 4px;
    .label {
      width: 60px;
      text-align: right;
      color: #666;
      display: inline-block;
    }
    .order-info {
      .my-el-row {
        box-sizing: border-box;
        border: 1px solid #f3f3f3;
        height: 35px;
        line-height: 35px;
        text-align: center;
      }


      .myInput {
        :deep(.el-input__inner) {
          border-radius: 0 !important;
        }
      }

      .order-list {
        font-size: 12px;

        .order-item {
          padding: 20px 0;
          &:not(:last-of-type) {
            border-bottom: 1px solid #f5f5f5;
          }

          .order-status {
            padding: 2px 9px;
            border-radius: 12px;
            background: #ebf1ff;
            color: #4073fa;

            &.wait-pay {
              color: #ff2c3c;
              background: rgba(255, 44, 60, 0.08);
            }

            &.danger-pay {
              background: red;
              color: #fff;
            }
          }
        }
      }
    }
  }
}

.my-btn {
  height: 20px;
  padding: 0;
  width: 50px;
}

.btn-send {
  text-align: center;
  line-height: 6px;
  height: 24px;
}

.goods-name{
  font-size: 12px;
}

.goods-price {
  color: #ff2c3c;
  font-size: 12px;
}

a {
  text-decoration: none;
  color: unset;
}

.redu {
  font-size: 12px;
  border-bottom: 1px solid #f5f5f5;
  margin-top: 6px;
  margin-bottom: 30px;
}

.redu div {
  margin-top: 4px;
}

.members{
  min-height: 400px;
  background: #f5f5f5;
  padding: 5px 0px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  font-size: 12px;
  .group_user{
    cursor: pointer;
    display: flex;
    gap:10px;
    margin:10px;
    .avatar{
      position: relative;
      width: 40px;
      height: 40px;
      border: 1px solid #fff;
      border-radius: 100px;
      overflow: hidden;
      .online {
        position: absolute;
        bottom: 0;
        text-align: center;
        width: 100%;
        background: #4dd74d;
        color: #fff;
        font-size: 10px;
      }
      .online.off{
        background: gray;
      }
    }
  }
  .role{
    font-size: 11px;
    box-sizing: border-box;
    height: 20px;
    border-radius: 5px;
    padding: 2px 5px;
    color: #fff;
  }

  .role_1 {
    background-color: #007aff;
  }
  .role_2 {
    background: #31cb30;
  }
  .role_3{
    background: #f60;
  }
}
.order-item {
  padding: 4px;
  margin: 2px;
  margin-bottom: 10px;
  background: #f5f7f9;
  border-radius: 5px;
}
.search_order{
  display: flex;
  width: 100%;
  justify-content: center;
}

.kanjia_dialog {
  //text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  .text1 {
    margin-top: 30px;
    font-size: 16px;
    font-weight: bold;
  }

  .text2 {
    margin-top: 10px;
    font-size: 12px;
    color: grey;
  }

  .text3 {
    margin-top: 10px;
    color: #fe8f7f;

    span {
      display: inline-block;
      margin-right: 10px;
    }

    :deep(.is-checked) {
      .el-radio__inner {
        background-color: #fe8f7f;
        border-color: #fe8f7f;
      }

      .el-radio__label {
        color: #fe8f7f;
      }
    }

  }

  .input {
    margin-top: 20px;
    display: flex;
    align-items: center;

    .text {
      width: 80px !important;
      height: 20px;
      line-height: 20px;
    }
  }

  .btn {
    margin: 35px 0;

    :deep(.el-button) {
      width: 150px !important;
      background-color: #FF7B15;
    }
  }
}
.el-icon-s-promotion{
  color:#4073FA;
  font-size: 16px;
}
.m-t-15{
  margin-top:2px;
}
.name.uid{
  font-size: 10px;
  color:gray;
}
.redu_price{
  color:red;
}
.old_price{
  color:gray;
}
.saler_price{
  color:gray;
}
.avatar-nickname{
  display: flex;
  align-items: center;
  gap:10px;
}
</style>